import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export default function PageHeader({
  title,
  subtitle,
  actions,
  hideActionsOnMobile = false,
}: {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  /** Drop the actions row below `sm` because the page shows them elsewhere there (the job pages move Sheet onto the Order details card). */
  hideActionsOnMobile?: boolean
}) {
  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <div>
        <h1 className="text-lg font-medium text-foreground">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-foreground/60">{subtitle}</p>}
      </div>
      {actions && (
        <div
          className={cn(
            // max-w-full: a long row (the order page has up to nine buttons)
            // wraps inside the page instead of running off its right edge.
            'max-w-full flex-wrap items-center gap-2 sm:w-auto sm:shrink-0',
            hideActionsOnMobile ? 'hidden sm:flex' : 'flex w-full',
          )}
        >
          {actions}
        </div>
      )}
    </div>
  )
}
